export default "__VITE_ASSET__11e9b694__"